import { isInteger } from 'lodash-es';
import { selectOrdinalCategory } from 'shared/utils';
import { toRef, toValue } from 'vue';
import { useI18n } from 'vue-i18n';

export interface IUseTranslateResponse extends ReturnType<typeof useI18n> {
  ordinalConversion(num?: number): string;

  translateSimpleEntityList<T extends { name: string }>(items: T[]): T[];
}

export function useTranslate(): IUseTranslateResponse {
  const all = useI18n({ useScope: 'global' });
  const { t } = all;

  return {
    ...all,
    // Overriding the te function, because it does not work. Returns true if the translation exists
    te(key: string): boolean {
      return t(key) !== key;
    },
    // TODO: this is very strange: sometimes the locale-property is not a ref anymore. seems like it will be unwrapped automatically somehow somewhere.
    locale: toRef(all.locale),
    ordinalConversion(num?: number) {
      if (num !== undefined && isInteger(num) && num >= 0) {
        const rule = selectOrdinalCategory(toValue(all.locale), num);
        return `${num}${t(`generic.ordinal.${rule}`)}`;
      }
      return '';
    },
    translateSimpleEntityList<T extends { name: string }>(items: T[]): T[] {
      return items.map((item) => ({
        ...item,
        name: t(item.name),
      })) as T[];
    },
  } as IUseTranslateResponse;
}
